import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import image1 from "../images/lapaz/image9.jpg";
import image2 from "../images/lapaz/image10.jpg";
import image3 from "../images/lapaz/image12.jpg";
import image4 from "../images/lapaz/image13.jpg";
import image5 from "../images/lapaz/image14.jpg";
import image6 from "../images/lapaz/image15.jpg";
import image7 from "../images/lapaz/image16.jpg";
import image8 from "../images/lapaz/image17.jpg";
import image9 from "../images/lapaz/image18.jpg";
import image10 from "../images/lapaz/image19.jpg";

export default function GaleriaLaPaz() {
  const [screenSize, setScreenSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    // Función para actualizar el tamaño de la pantalla
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Agregar el evento de redimensionamiento
    window.addEventListener("resize", handleResize);

    // Eliminar el evento para evitar fugas de memoria
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <ImageList
      sx={{
        height: 450,
      }}
      cols={screenSize.width >= 600 ? 3 : 2}
      rowHeight={200}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: image1,
    title: "Ambientes DLS La Paz",
  },
  {
    img: image2,
    title: "ambiente DLS La Paz",
  },
  {
    img: image3,
    title: "ambiente DLS La Paz",
  },
  {
    img: image4,
    title: "ambiente DLS La Paz",
  },
  {
    img: image5,
    title: "ambiente DLS La Paz",
  },
  {
    img: image6,
    title: "ambiente DLS La Paz",
  },
  {
    img: image7,
    title: "ambiente DLS La Paz",
  },
  {
    img: image8,
    title: "ambiente DLS La Paz",
  },
  {
    img: image9,
    title: "ambiente DLS La Paz",
  },
  {
    img: image10,
    title: "ambiente DLS La Paz",
  },
];
